/**
 * Shareable app state in the query string. The SPA is served as static files at
 * the site root, so state lives in `?view=…&bank=…` rather than in the path.
 */
export function readParams(): URLSearchParams {
  return new URLSearchParams(window.location.search);
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** A `YYYY-MM-DD` query value, or '' when it is missing or malformed. */
export function dateParam(params: URLSearchParams, key: string): string {
  const value = params.get(key) ?? '';
  return ISO_DATE.test(value) && !Number.isNaN(Date.parse(value)) ? value : '';
}

export function writeParams(values: Record<string, string | null | undefined>, mode: 'push' | 'replace') {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(values)) {
    if (value) params.set(key, value);
  }
  const search = params.toString();
  const url = `${window.location.pathname}${search ? `?${search}` : ''}`;
  if (url === `${window.location.pathname}${window.location.search}`) return;
  if (mode === 'push') window.history.pushState(null, '', url);
  else window.history.replaceState(null, '', url);
}
